<!-- `@if(icon)` keeps a pinned totals row (no `params.data`, so no icon) from emitting
     `<img src="">` and the browser's broken-image glyph. -->
@if(icon && !isHidden){
<img [ngClass]="{'no-active': !isActive}" [src]="icon" style="width: 20px" alt="" />
}